// utils/guest.js

export const isGuest = () => {
    return localStorage.getItem('isGuest') === 'true';
  };
  
  export const setGuest = (value) => {
    localStorage.setItem('isGuest', value ? 'true' : 'false');
  };
  